import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import TabSelection from '../TabSelection';
import PatientCaseDetailsTab from '../PatientCaseDetailsTab';
import PatientCaseHistoryTab from '../PatientCaseHistoryTab';
import { PatientCasesMessages } from '../../../core-utils/messages/PatientCasesMessages';

export interface PatientCasesTabsProps {
  memberId: string;
  caseId: string;
  triggerAPI: boolean;
  patientId?: string;
  interactionState?: [any, React.Dispatch<React.SetStateAction<any>>];
}

interface TabContentProps {
  selectedTabIndex: number;
  caseId: string;
  memberId: string;
  triggerAPI: boolean;
  patientId?: string;
  interactionState?: [any, React.Dispatch<React.SetStateAction<any>>];
}
const TabContent: React.FC<TabContentProps> = ({
  selectedTabIndex,
  caseId,
  memberId,
  triggerAPI,
  patientId,
  interactionState,
}) => {
  switch (selectedTabIndex) {
    case 0:
      return (
        <PatientCaseDetailsTab
          caseId={caseId}
          triggerAPI={triggerAPI}
          interactionState={interactionState}
        />
      );
    case 1:
      return (
        <PatientCaseHistoryTab
          memberId={patientId || memberId}
          triggerAPI={triggerAPI}
        />
      );
    default:
      return <></>;
  }
};

const PatientCasesTabs: React.FC<PatientCasesTabsProps> = ({
  memberId,
  caseId,
  triggerAPI,
  patientId,
  interactionState,
}) => {
  const {
    classes
  } = makeStyles()({
    tabsContainer: {
      '& .MuiGrid-item': {
        margin: '0px !important',
        '& .MuiTabs-root': {
          marginLeft: '34px',
        },
      },
    },
  })();

  const messages = PatientCasesMessages;

  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
  };

  return (
    <Grid className={classes.tabsContainer}>
      <TabSelection
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={handleSelectedIndex}
        tabList={messages.TABS}
      />

      <TabContent
        selectedTabIndex={selectedTabIndex}
        caseId={caseId}
        memberId={memberId}
        triggerAPI={triggerAPI}
        patientId={patientId}
        interactionState={interactionState}
      />
    </Grid>
  );
};

export default PatientCasesTabs;
